module.exports = __webpack_public_path__ + "assets/img/11bp_725_3.9ca784e0.jpg";